<!-- <ion-header [translucent]="true">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title class="animated slideInDown">{{ pageTitle }}</ion-title>
        <ion-buttons slot="end" *ngIf="onCancel !== undefined">
            <ion-button (click)="cancel()">
                <ion-icon name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header> -->

<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>

    <!-- Replace ion-title with a custom div -->
    <!-- <div class="custom-title" slot="primary">
      {{ pageTitle }}
    </div> -->

    <div class="custom-title" slot="primary" [innerHTML]="pageTitle"></div>


    <ion-buttons slot="end" *ngIf="onCancel !== undefined">
      <ion-button (click)="cancel()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
